import { render } from "./ResetEmail.vue?vue&type=template&id=06566a84"
import script from "./ResetEmail.vue?vue&type=script&lang=js"
export * from "./ResetEmail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__